import React, { MouseEvent, ReactNode, useRef, useState, JSX, RefObject } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import useConfig from '../../Hooks/useConfig';
import { PopoverProps, UncontrolledPopover } from 'reactstrap';

const InfoPopover = (props: {
  text: ReactNode;
  retentionTime?: number;
  className?: string;
  popoverClassName?: string;
  popoverInnerClassName?: string;
  placement?: PopoverProps['placement'];
  onlyUseClick?: boolean;
  popoverStateOverride?: { popoverOpen: boolean; setPopoverOpen: (popoverOpen: boolean) => void };
}): JSX.Element => {
  const {
    text,
    retentionTime,
    className,
    popoverClassName,
    popoverInnerClassName,
    placement,
    onlyUseClick,
    popoverStateOverride
  } = props;
  const [popoverOpen, setPopoverOpen] = useState<boolean>(false);
  const isPopoverOpenValue = !!popoverStateOverride
    ? popoverStateOverride.popoverOpen
    : popoverOpen;
  const config = useConfig();
  const iconRef = useRef<SVGSVGElement | undefined>(null);

  let timeout: ReturnType<typeof setTimeout> | undefined;

  const handleSetPopoverOpen = (isPopoverOpen: boolean): void => {
    if (!!popoverStateOverride) {
      popoverStateOverride.setPopoverOpen(isPopoverOpen);
    } else {
      setPopoverOpen(isPopoverOpen);
    }
  };

  const handleMouseLeave = () => {
    if (retentionTime && retentionTime > 0) {
      if (timeout) {
        timeout.refresh();
      } else {
        timeout = setTimeout(() => {
          handleSetPopoverOpen(false);
        }, retentionTime);
      }
    } else {
      handleSetPopoverOpen(false);
    }
  };

  const toggle = () => {
    handleSetPopoverOpen(!isPopoverOpenValue);
  };

  return (
    <span className={className || ''}>
      <FontAwesomeIcon
        ref={iconRef as RefObject<SVGSVGElement> | undefined}
        className="camper-item__popover__icon"
        icon={faInfoCircle}
        onMouseEnter={!onlyUseClick ? (): void => handleSetPopoverOpen(true) : undefined}
        onMouseLeave={!onlyUseClick ? handleMouseLeave : undefined}
        onClick={(e: MouseEvent<HTMLOrSVGElement>): void => {
          e.stopPropagation();
          toggle();
        }}
      />
      <UncontrolledPopover
        className={`${popoverClassName || 'camper-item__popover__container'} ${
          config.modalContainerClass || ''
        }`}
        isOpen={isPopoverOpenValue}
        placement={placement || 'bottom'}
        container={
          config.outsideElementsContainerId
            ? window?.document?.getElementById(config.outsideElementsContainerId) || undefined
            : undefined
        }
        target={(iconRef as unknown) as RefObject<HTMLElement>}
        toggle={toggle}
        trigger="legacy"
      >
        <div
          className={`camper-item__popover ${popoverInnerClassName || ''}${
            onlyUseClick ? ' camper-item__popover--click' : ''
          }`}
          onClick={onlyUseClick ? () => handleSetPopoverOpen(false) : undefined}
        >
          {text}
        </div>
      </UncontrolledPopover>
    </span>
  );
};

export default InfoPopover;
